<template>
  <div class="w-full flex flex-col justify-center">
    <!-- Essentials Copy  -->
    <div class="bg-white py-0">
      <div class="mx-auto px-5" style="max-width: 1000px">
        <h1
          data-qa='title_text'
          class="text-center text-gray-1000 font-bold mt-8 mb-4"
          :class="{
            'ds-text-4xl': !isDesktop,
            'lg-header': isDesktop,
          }"
        >
          {{copy.headerText}}
        </h1>
        <p
          data-qa='subtitle_text'
          class="ds-text-base lg:ds-text-2xl text-gray-900 font-normal text-center mb-5"
        >
          {{copy.subheadingText}}
        </p>
        <div
          class="feature-icons-container w-auto md:mx-auto my-0 mb-8 flex flex-col md:flex-row items-start md:items-center md:items-start md:justify-center md:space-x-6"

        >
          <CopyBox
            v-for="({ image, copy}, v) in enhancedCopyBoxes"
            :key="v"
            :image="image"
            :copy="copy"
            :dataIndex="v"
          />
        </div>
      </div>
    </div>
    <!-- /Essentials Copy  -->
    <div class="p-2 bg-half-white">
      <div class="max-w-1200 mx-auto">
        <div
          id="pricing-essentials"
          class="rounded-lg p-4 bg-cover"
          :style="backgroundStyle"
        >
          <PremiumOption />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PremiumOption from "./Option/PricingPremiumOption";
import CopyBox from "./PricingPremiumIconCopyBox";
import RosterNeedsFeatureSVG from "./SVG/RosterNeedsFeatureSVG";
import { mapState } from "vuex";

export default {
  components: {
    PremiumOption,
    CopyBox,
    RosterNeedsFeatureSVG
  },
  data() {
    return {
      copy: {
        headerText: "Every coach in one place.",
        subheadingText:
          "IWLCARecruits is where women’s lacrosse recruiting happens. Maximize your recruiting efforts and upgrade to Pro today.",
      },
      copyBoxes: [
        {
          copy: "Official Recruiting Platform of the IWLCA",
          image:
            "https://cdn.sportsrecruits.com/assets/itg/IWLCA-shield.svg",
        },
        {
          copy: "Messaging System and College Views",
          image:
            "https://cdn.sportsrecruits.com/assets/itg/messaging-system-college-views.svg",
        },
        {
          copy: "Access to Film from Top Events",
          image:
            "https://cdn.sportsrecruits.com/assets/itg/IWLCA-film.svg",
        },

      ],
    };
  },
  computed: {
    ...mapState("pricing", ["rosterNeedsEnabled"]),
    isDesktop() {
      return ["lg", "xl"].includes(this.$mq);
    },
    backgroundStyle() {
      return {
        backgroundImage: `url('https://cdn.sportsrecruits.com/assets/itg/iwlca_lacrosse-field-blue-bg.jpg')`,
      };
    },
    enhancedCopyBoxes() {
      if(this.rosterNeedsEnabled)
        this.copyBoxes.push({ 
          image: RosterNeedsFeatureSVG,
          copy: "Roster Needs Search Filter"
        });

      return this.copyBoxes;
    }
  },
  mounted() {
    this.$emit("hasMounted");
  },
};
</script>

<style scoped>
@media (min-width: 768px) {
  .feature-icons-container {
    height: 168px;
  } 
}
</style>